export const config = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? '/api/v2',
  descopeProjectId: import.meta.env.VITE_DESCOPE_PROJECT_ID as string,
};
